import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Flex, FlexColumn, NumberDisplay, Separator, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Avatar } from "../Avatar";
import { ViewItemsOnProfileButton } from "../ViewItemsOnProfileButton";
import { TransactionReceiptFragment } from "./TransactionReceipt.fragment";
export const TransactionReceiptCollectionFragment = graphql(`
  fragment TransactionReceiptCollection on Collection {
    imageUrl
  }
`);
export function TransactionReceipt(t0) {
  const $ = _c(20);
  const {
    receipt: receiptKey,
    collection: collectionKey,
    flowType,
    walletDestination
  } = t0;
  const t = useTranslations("wallet.TransactionReceipt");
  let t1;
  let t2;
  let t3;
  if ($[0] !== collectionKey || $[1] !== flowType || $[2] !== receiptKey || $[3] !== t || $[4] !== walletDestination?.address) {
    const receipt = readFragment(TransactionReceiptFragment, receiptKey);
    let t4;
    if ($[8] !== collectionKey) {
      t4 = readFragment(TransactionReceiptCollectionFragment, collectionKey);
      $[8] = collectionKey;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    const collection = t4;
    const totalSpent = receipt.totalSpent?.pricePerToken[0];
    const t5 = `${flowType}.title`;
    let t6;
    if ($[10] !== t || $[11] !== t5) {
      t6 = t(t5);
      $[10] = t;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const title = t6;
    const t7 = `${flowType}.totalLabel`;
    let t8;
    if ($[13] !== t || $[14] !== t7) {
      t8 = t(t7);
      $[13] = t;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    const totalLabel = t8;
    const viewOnProfile = flowType !== "acceptOffer";
    const itemReceiptsQuantity = receipt.itemReceipts.reduce(_temp, 0);
    const failedItemReceiptsQuantity = receipt.failedItemReceipts.reduce(_temp2, 0);
    t1 = receipt.itemReceipts.length !== 0 && <><Separator /><FlexColumn className="w-full gap-4"><SpaceBetween className="items-center"><TextBody size="md" weight="semibold">{itemReceiptsQuantity} {title}</TextBody><Flex className="gap-4">{receipt.itemReceipts.slice(0, 3).map(itemReceipt_1 => <Avatar frameTime={1} key={itemReceipt_1.item?.id} size={48} src={itemReceipt_1.item?.imageUrl ?? collection?.imageUrl ?? undefined} />)}</Flex></SpaceBetween><SpaceBetween><TextBody size="xs" weight="semibold">{totalLabel}</TextBody><FlexColumn className="justify-end"><NumberDisplay suffix={totalSpent?.token.symbol} value={totalSpent?.token.unit} /></FlexColumn></SpaceBetween></FlexColumn></>;
    t2 = receipt.failedItemReceipts.length !== 0 && <><Separator /><SpaceBetween className="w-full items-center"><TextBody size="md" weight="semibold">{failedItemReceiptsQuantity} {t("failed")}</TextBody><Flex className="gap-4 opacity-40">{receipt.failedItemReceipts.slice(0, 3).map(itemReceipt_2 => <Avatar frameTime={1} key={itemReceipt_2.item?.id} size={48} src={itemReceipt_2.item?.imageUrl ?? collection?.imageUrl ?? undefined} />)}</Flex></SpaceBetween></>;
    t3 = receipt.itemReceipts.length !== 0 && viewOnProfile && <><Separator /><ViewItemsOnProfileButton itemIds={receipt.itemReceipts.flatMap(_temp3)} walletDestinationAddress={walletDestination?.address} /></>;
    $[0] = collectionKey;
    $[1] = flowType;
    $[2] = receiptKey;
    $[3] = t;
    $[4] = walletDestination?.address;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function _temp3(itemReceipt_3) {
  return itemReceipt_3.item ? [itemReceipt_3.item.id] : [];
}
function _temp2(acc_0, itemReceipt_0) {
  return acc_0 + itemReceipt_0.quantity;
}
function _temp(acc, itemReceipt) {
  return acc + itemReceipt.quantity;
}